// extracted by mini-css-extract-plugin
export var arrow = "bw_d1";
export var profile = "bw_d0";
export var text = "bw_dV";